//=include _owl.carousel.min.js

$(document).ready(function() {
	if ($('#actualite_carrousel').length > 0) {
		$('#actualite_carrousel').owlCarousel({
			loop: true,
			items: 1,
			nav: false,
			margin: 0,
			autoplay: true,
			autoplayTimeout: 4000,
			autoplayHoverPause: false
		});
	}
});
